import { render, staticRenderFns } from "./ShoppingCartSave.vue?vue&type=template&id=3f8709a6"
import script from "./ShoppingCartSave.vue?vue&type=script&lang=js"
export * from "./ShoppingCartSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports